import { useEffect, useState } from "react";
import { isPastDeadline } from "@/lib/orderDeadline";

export function useIsPastDeadline(): boolean {
  const [expired, setExpired] = useState<boolean>(() => isPastDeadline());

  useEffect(() => {
    if (expired) return;
    const id = setInterval(() => {
      if (isPastDeadline()) {
        setExpired(true);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [expired]);

  return expired;
}
